import React from "react";

/**
 * Footer control to enter/exit browser fullscreen (used with useFullscreen).
 */
export default function FullscreenToggleButton({ isFullscreen, onToggle }) {
  return (
    <button
      type="button"
      className="btn btn-link nav-link p-0"
      onClick={onToggle}
      title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
      aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
      style={{
        textDecoration: "none",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <iconify-icon
        className="footer-icon-strong"
        icon={isFullscreen ? "mdi:fullscreen-exit" : "mdi:fullscreen"}
        style={{
          fontSize: "20px",
          filter:
            "drop-shadow(0 0 0 currentColor) drop-shadow(0 0 0 currentColor)",
        }}
      />
    </button>
  );
}
